import './banner-text-image-action.scss'
import { ImageWithFocalPoint } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import type { BannerTextImageActionPropsApi } from '@/common/components/bannerTextImageAction/models'
import { CtaButton } from '@/common/components/ctaButton/CtaButton'
import { cx } from '@/common/utils/className'

export interface BannerTextImageActionProps extends BannerTextImageActionPropsApi {}

export const BannerTextImageAction: FC<BannerTextImageActionProps> = props => {
    const {
        image,
        centerAlignText,
        description,
        title,
        backgroundColor: { label },
        actionLinkBackground,
        actionLink,
        setTitleToH1,
        imageFirst,
    } = props ?? {}

    const HElement = setTitleToH1 ? 'h1' : 'h3'

    const bannerCls = cx('banner-text-image-action', { 'with-image': !!image, 'image-first': !!imageFirst })
    const pCls = cx({ 'text-center': !!centerAlignText })
    const hCls = cx('title', { 'text-center': !!centerAlignText })

    const desktop = {
        ...(title
            ? {
                  width: 856,
                  height: 520,
              }
            : {
                  width: 606,
                  height: 350,
              }),
    }

    return (
        <div className={bannerCls}>
            {image && (
                <div className="banner-image">
                    <ImageWithFocalPoint
                        {...image}
                        dimensions={{
                            ...desktop,
                            desktop,
                            tablet: {
                                width: 592,
                                height: 534,
                            },
                            mobile: {
                                width: 735,
                                height: 413,
                            },
                            portrait: {
                                width: 393,
                                height: 221,
                            },
                        }}
                    />
                </div>
            )}
            <div className={`content bg-${label}`}>
                {title && <HElement className={hCls}>{title}</HElement>}
                {description && <p className={pCls}>{description}</p>}
                {actionLink && <CtaButton link={actionLink} buttonColor={actionLinkBackground} />}
            </div>
        </div>
    )
}
